<template>
    <a-modal
        centered
        :visible="visible"
        :keyboard="false"
        :mask-closable="false"
        title="客户重新实名认证"
        @ok="on_ok"
        @cancel="on_cancel"
        :confirmLoading="submitting"
        :after-close="after_close"
        :width="480"
    >
        <a-alert message="请注意" description="发起重新认证后，无法是否认证成功都会取消之前的认证结果。" type="info" show-icon style="margin-bottom:24px"/>

        <a-form-model :model="form" ref="_form" :rules="rules">
            <a-form-model-item label="认证类型" prop="type">
                <a-radio-group v-model="form.type" button-style="solid">
                    <a-radio-button :value="1">
                        个人认证
                    </a-radio-button>
                    <a-radio-button :value="2">
                        企业认证
                    </a-radio-button>
                </a-radio-group>
            </a-form-model-item>
        </a-form-model>
    </a-modal>
</template>
<script>
    let init_form = {
        type: 1,
        member_id: null,
    };
    export default {
        props: {
            visible: {
                default: false,
            },
            member_id: null,
            callback: null,
        },
        created() {
            this.form = JSON.parse(JSON.stringify(init_form));
        },
        data() {
            return {
                submitting: false,
                form: {},
                rules: {
                    member_id: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "必填",
                        },
                    ],
                    type: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "必填",
                        },
                    ],
                },
            };
        },
        watch: {
            // visible(e) {
            //     if (e) {
            //         this.form = JSON.parse(JSON.stringify(init_form));
            //     }
            // },
            member_id(e) {
                if (e) {
                    this.form.member_id = e;
                }
            },
        },
        methods: {
            on_cancel() {
                this.$emit("close");
            },
            on_ok() {
                this.$refs["_form"].validate((valid) => {
                    if (valid) {
                        this.submitting = true;

                        this.$http
                            .post("certification/verify/renew", this.form)
                            .then((res) => {
                                if (res.success) {
                                    this.$success({
                                        title: "请求成功，请将该链接地址发给客户进行实名认证",
                                        centered: true,
                                        content: res.data.url,
                                    });

                                    this.on_cancel();
                                    if (this.callback) {
                                        this.callback();
                                    }
                                } else {
                                    this.$error({
                                        title: "失败",
                                        centered: true,
                                        content: res.message,
                                    });
                                }
                            })
                            .catch(() => {})
                            .then(() => {
                                this.submitting = false;
                            });
                    } else {
                        this.$message.error("请检查并填写完需要录入的内容");
                        return false;
                    }
                });
            },

            after_close() {
                this.form = JSON.parse(JSON.stringify(init_form));

                this.$refs["_form"].resetFields();
            },
        },
    };
</script>
 